const generator = require('generate-password');
export default  generator
